
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductBooksGrid1 extends Serenity.EntityGrid<ProductBooksRow, any> {
        protected getColumnsKey() { return 'Products.ProductBooks'; }
        protected getDialogType() { return ProductBooksDialog; }
        protected getIdProperty() { return ProductBooksRow.idProperty; }
        protected getInsertPermission() { return ProductBooksRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductBooksRow.localTextPrefix; }
        protected getService() { return ProductBooksService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {
            // debugger;
          //s  this.editItem({ ProductId: this.ProductId });
            this.editItem({ ProductId: this.ProductId, IsTab: true });


        }
        protected getQuickFilters() {

            var filters = super.getQuickFilters();
            filters.splice(Q.indexOf(filters, x => x.field == "BookId"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "ProductId"), 1);


            return filters;

        }
        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.ProductId != null;
        }

        private _ProductId: number;

        get ProductId() {
            return this._ProductId;
        }

        set ProductId(value: number) {
            //debugger;
            if (this._ProductId != value) {
                this._ProductId = value;
                this.setEquality(ProductBooksRow.Fields.ProductId, value);
                this.refresh();
            }
        }
    }
}